import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router-dom';
import ShsExperienceDetails from './pages/ShsExperienceDetails';
import SurveyFeedback from './pages/SurveyFeedback/SurveyFeedback';
import JoinResearchPanel from './pages/JoinResearchPanel/JoinResearchPanel';
import ShsRedirect from './pages/ShsRedirect/ShsRedirect';
import { applyMiddleware, createStore, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { AppointmentTimePickerReducer } from './components/common/TimePicker/reducer/AppointmentTimePickerReducer';
import testimonialsReducer from './components/common/Testimonials/reducer';
import experiencesReducer from './reducers/Experiences';
import callMeNowReducer from './reducers/CallMeNow';
import bootstrapCssUrl from '!file-loader!bootstrap/dist/css/bootstrap.min.css';
import mainCssUrl from '!file-loader?name=[hash].css!extract-loader!css-loader!sass-loader!./main.scss';
import queryString from 'query-string';
import { handleAdobePageAnalytics } from 'packages/smart-home-support/utils';
import ShsExperiences from './pages/ShsExperiences';
import analyticsContext from './components/analytics/Analytics';
import Unsubscribe from './pages/Unsubscribe/Unsubscribe';
import onboarding from './pages/onboarding/onboarding';
import Questionar from './pages/onboarding/questionar';
import Result from './pages/onboarding/result';
import getPartnerAsset, { DynamicAssetsKeys } from 'packages/smart-home-support/assets';

let rootReducer = combineReducers({
  timePicker: AppointmentTimePickerReducer,
  testimonials: testimonialsReducer,
  experiences: experiencesReducer,
  callMeNow: callMeNowReducer,
});
const middleware = applyMiddleware(thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export let store = createStore(rootReducer, composeEnhancers(middleware));

const getRoutePath = (path) => `${getPartnerAsset(DynamicAssetsKeys.expertSessionsPath)}${path ? `/${path}` : ''}`;

export default class ExperiencesRouter extends Component {
  setMinimalHeader() {
    if (this.props.headerConfig.isSticky) this.props.setIsHeaderSticky(false);
    if (this.props.headerConfig.isNavigable) this.props.setIsHeaderNavigable(false);
  }

  setMinimalStickyHeader() {
    if (!this.props.headerConfig.isSticky) this.props.setIsHeaderSticky(true);
    if (this.props.headerConfig.isNavigable) this.props.setIsHeaderNavigable(false);
  }

  setFullHeader() {
    if (!this.props.headerConfig.isSticky) this.props.setIsHeaderSticky(true);
    if (!this.props.headerConfig.isNavigable) this.props.setIsHeaderNavigable(true);
  }

  setMinimalFooter() {
    if (!this.props.isAgent) this.props.setIsAgent(true);
  }

  setFullFooter() {
    if (this.props.isAgent) this.props.setIsAgent(false);
  }

  componentDidUpdate() {
    const { pathname } = this.props.location;
    if (
      pathname === getRoutePath('feedback') ||
      pathname === getRoutePath('joinresearchpanel') ||
      pathname === getRoutePath('email/unsubscribe') ||
      pathname === getRoutePath('email/redirect')
    ) {
      this.setMinimalHeader();
    } else if (
      pathname === getRoutePath('onboarding') ||
      pathname === getRoutePath('onboarding/questionnaire') ||
      pathname === getRoutePath('onboarding/result')
    ) {
      this.setMinimalStickyHeader();
    } else {
      this.setFullHeader();
    }
    if (pathname === getRoutePath('onboarding/questionnaire')) {
      this.setMinimalFooter();
    } else {
      this.setFullFooter();
    }
  }

  renderPageContents = () => {
    const queryData = queryString.parse(this.props.location.search);
    const megaUseCase = queryData && queryData.megaUseCase;

    if (!!megaUseCase) {
      return <ShsExperienceDetails />;
    } else {
      return <ShsExperiences />;
    }
  };

  render() {
    return (
      <Provider store={store}>
        <Helmet defer={false}>
          <link rel="stylesheet" type="text/css" href={bootstrapCssUrl} />
          <link rel="stylesheet" type="text/css" href={mainCssUrl} />
        </Helmet>
        <Switch>
          <Route exact path={getRoutePath()} render={this.renderPageContents} />
          <Route exact path={getRoutePath('feedback')} component={SurveyFeedback} />
          <Route exact path={getRoutePath('joinresearchpanel')} component={JoinResearchPanel} />
          <Route exact path={getRoutePath('email/unsubscribe')} component={Unsubscribe} />
          <Route exact path={getRoutePath('email/redirect')} component={ShsRedirect} />
          <Route exact path={getRoutePath('onboarding')} component={onboarding} />
          <Route exact path={getRoutePath('onboarding/questionnaire')} component={Questionar} />
          <Route exact path={getRoutePath('onboarding/result')} component={Result} />
        </Switch>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/index.js